import { useGetByTerm } from 'fileIndexing/entities/useEntities';
import { IEntityTypeFilter } from 'fileIndexing/files/interfaces/IFiles';
import { useGetAllDataGroups } from 'fileIndexing/taxonomies/useTaxonomy';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { GeopostAutocomplete } from './GeopostAutocomplete';

export function GeopostAutocompleteEntities({ fieldName, label, selectedValue, setReloadDropdowns, required = false }: Props) {
    const [dataGroupItems, setDataGroupItems] = useState<{ id: string; label: string; }[]>([]);
    const [inputValue, setInputValue] = useState<string>('');

    const { data: dataEntities, isLoading } = useGetByTerm(inputValue);

    useEffect(() => {
        if (dataEntities) {
            let getAllDataGroups = dataEntities.map(dataEntities => ({
                id: dataEntities.Token,
                label: dataEntities.Name
            }));

            setDataGroupItems(getAllDataGroups);
        }
    }, [dataEntities]);

    useEffect(() => {
        if (selectedValue && selectedValue.label !== '') {
            setInputValue(selectedValue.label);

        }
        else if (selectedValue === null) {
            setInputValue('');
        }
    }, [selectedValue]);

    useEffect(() => {
        if (setReloadDropdowns) {
            setReloadDropdowns((prev: number) => prev + 1);
        }
    }, [inputValue]);

    return (
        <GeopostAutocomplete fieldName={fieldName} label={label} items={dataGroupItems} selectedValue={selectedValue} setInputValue={setInputValue} loading={isLoading} required={required} />
    );
}

interface Props {
    fieldName: string;
    label: string;
    selectedValue: IEntityTypeFilter;
    setReloadDropdowns?: Dispatch<SetStateAction<number>>;
    required?: boolean;
}